export default __webpack_public_path__ + "cardModelNlp-sill186d59.png";